"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.forEachKey = void 0;
function forEachKey(subject, predicate, thisArg) {
    return Object.keys(subject).forEach(predicate, thisArg);
}
exports.forEachKey = forEachKey;
//# sourceMappingURL=forEachKey.js.map